module.exports = __webpack_public_path__ + "img/productSatellite_23.558398a3.png";